import { GetterTree } from 'vuex';
import { State } from '@/manager/client/store/state';
import { Client } from '@/manager/client/client.model';

export interface Getters {
  getClientList: Client[];
}

export const getters: GetterTree<State, any> = {
  getClientList: (state) => state.list,
  getClient(state: State) {
    return (id: string) => {
      return state.list.find((client: any) => {
        return client.user.id === id;
      });
    };
  },
  acquiredCoursesList(state: State) {
    return state.acquiredCoursesList;
  },
  getAcquiredCourse(state: State) {
    return (productId: string) => {
      const productList = state.acquiredCoursesList.products || [];
      return productList.find((product: any) => product.id === productId);
    };
  },
  getGenderFilter(state: State) {
    return state.genderFilter;
  },
  getClientPaginationInfo(state: State) {
    return state.clientPaginationInfo;
  },
  getSearchString(state: State) {
    return state.searchString;
  },
  getLocationFilter(state: State) {
    return state.locationFilter;
  },
  getProcedencyFilter(state: State) {
    return state.procedencyFilter;
  },
  getLevelUpDataFilter(state: State) {
    return state.levelUpDataFilter;
  },
  getCurseFilter(state: State) {
    return state.curseFilter;
  },
  getConferenceFilter(state: State) {
    return state.conferenceFilter;
  },
  getEventsFilter(state: State) {
    return state.eventsFilter;
  },
  getTagsFilter(state: State) {
    return state.tagsFilter;
  },
  getFiscalDataFilter(state: State) {
    return state.fiscalDataFilter;
  },
  getClientDateFilter(state: State) {
    return state.clientDateFilter;
  },
  procedencyList(state: State) {
    return state.procedencyList;
  },
  clientTagList(state: State) {
    return state.tagsList;
  },
  getSearchFiscalDataExtension(state: State) {
    return state.searchFiscalDataExtension;
  },
};
